export default "__VITE_ASSET__BONP6qKS__"